import { render, staticRenderFns } from "./UnitEdit.vue?vue&type=template&id=4647f1e2&scoped=true&"
import script from "./UnitEdit.vue?vue&type=script&lang=js&"
export * from "./UnitEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnitEdit.vue?vue&type=style&index=0&id=4647f1e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647f1e2",
  null
  
)

export default component.exports